import { render, staticRenderFns } from "./HedgingOverviewReportTemplate.vue?vue&type=template&id=04d97a6c"
import script from "./HedgingOverviewReportTemplate.vue?vue&type=script&lang=js"
export * from "./HedgingOverviewReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./HedgingOverviewReportTemplate.vue?vue&type=style&index=0&id=04d97a6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports